import {raf} from "./util";

export function registerScrollTo() {
    raf(() => Array.prototype.slice.call(document.querySelectorAll("[data-scroll-to]")).forEach(el => initializeScrollAnchor(el)));
}

function initializeScrollAnchor(el) {
    const target = el.dataset.scrollTo;

    el.addEventListener("click", evt => {
        evt.preventDefault();

        document.querySelector(target).scrollIntoView({block: "center", inline: "center", behavior: "smooth"});
    });
}
